export function validatePersonalizationResponse(sections, requestedKeys) {
  const validSections = [];
  const unknownKeys = [];

  sections.forEach((section) => {
    const validItems = section.items.filter((item) => {
      const isKnown = requestedKeys.has(item.key);

      if (!isKnown) {
        unknownKeys.push(item.key);
      }

      return isKnown && typeof item.copy === 'string' && item.copy.trim().length > 0;
    });

    if (validItems.length > 0) {
      validSections.push({
        section: section.section,
        items: validItems
      });
    }
  });

  return {
    sections: validSections,
    unknownKeys
  };
}
